module.exports = __webpack_public_path__ + "img/default.af5d8752.png";